import React from 'react';
import {Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import FlashMessage from '@/components/flash-message';
import {FlashMessageOptions} from '@/components/flash-messages-service/flashMessageTypes';
import {flashMessagesActions} from '@/stores/flashMessagesStore';

function raiseFlashMessage(options: FlashMessageOptions) {
  const flashMessage = flashMessagesActions.addFlashMessage(options);
  return () => flashMessagesActions.removeFlashMessage(flashMessage);
}

export function raiseFlashMessageError(options?: {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
}) {
  const title = options?.title ?? translate(`errors.something-went-wrong`);
  const subtitle =
    options?.subtitle ??
    translate(`errors.please-try-again-or-come-back-later`);
  const icon = options?.icon ?? (
    <Icon size="large" appearance="danger" name="Navigation-Attention" />
  );
  raiseFlashMessage({
    status: 'error',
    icon,
    mode: 'light',
    message: <FlashMessage.Banner title={title} subtitle={subtitle} />,
  });
}

export default raiseFlashMessage;
